import {
  shortcuts
} from "./chunk-XJWZA7KQ.mjs";
import {
  container,
  editor,
  textarea
} from "./chunk-PW2VLYXQ.mjs";
import {
  htmlEncode,
  processHtml
} from "./chunk-ZOV2YOCF.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/Editor.tsx
import React, { useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Editor_default = React.forwardRef((props, ref) => {
  const _a = props, {
    prefixCls = "w-tc-editor",
    value: _,
    padding = 10,
    minHeight = 16,
    placeholder,
    language,
    themeMode,
    className,
    style,
    contentStyle: _contentStyle,
    rehypePlugins,
    onChange,
    indentWidth = 2
  } = _a, other = __objRest(_a, [
    "prefixCls",
    "value",
    "padding",
    "minHeight",
    "placeholder",
    "language",
    "themeMode",
    "className",
    "style",
    "contentStyle",
    "rehypePlugins",
    "onChange",
    "indentWidth"
  ]);
  const [value, setValue] = useState(props.value || "");
  useEffect(() => setValue(props.value || ""), [props.value]);
  const inputRef = useRef(null);
  useImperativeHandle(ref, () => inputRef.current, [inputRef]);
  const contentStyle = __spreadValues({
    paddingTop: typeof padding === "object" ? padding.top : padding,
    paddingRight: typeof padding === "object" ? padding.right : padding,
    paddingBottom: typeof padding === "object" ? padding.bottom : padding,
    paddingLeft: typeof padding === "object" ? padding.left : padding
  }, _contentStyle);
  const htmlStr = useMemo(
    () => processHtml(
      `<pre aria-hidden=true><code ${language && value ? `class="language-${language}"` : ""} >${htmlEncode(
        String(value || "")
      )}</code><br /></pre>`,
      rehypePlugins
    ),
    [value, language, rehypePlugins]
  );
  const preview = useMemo(
    () => /* @__PURE__ */ jsx(
      "div",
      {
        style: __spreadProps(__spreadValues(__spreadValues({}, editor), contentStyle), { minHeight }),
        className: `${prefixCls}-preview ${language ? `language-${language}` : ""}`,
        dangerouslySetInnerHTML: {
          __html: htmlStr
        }
      }
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [prefixCls, language, htmlStr]
  );
  const change = (evn) => {
    setValue(evn.target.value);
    onChange && onChange(evn);
  };
  const keyDown = (evn) => {
    if (other.readOnly) return;
    if (!other.onKeyDown || other.onKeyDown(evn) !== false) {
      shortcuts(evn, indentWidth);
    }
  };
  const textareaProps = __spreadProps(__spreadValues({
    autoComplete: "off",
    autoCorrect: "off",
    spellCheck: "false",
    autoCapitalize: "off"
  }, other), {
    placeholder,
    style: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, editor), textarea), contentStyle), {
      minHeight
    }), placeholder && !value ? { WebkitTextFillColor: "inherit" } : {}),
    onChange: change,
    onKeyDown: keyDown,
    className: `${prefixCls}-text`,
    value
  });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: __spreadValues(__spreadValues({}, container), style),
      className: `${prefixCls} ${className || ""}`,
      "data-color-mode": themeMode,
      children: [
        /* @__PURE__ */ jsx("textarea", __spreadProps(__spreadValues({}, textareaProps), { ref: inputRef })),
        preview
      ]
    }
  );
});

export {
  Editor_default
};
//# sourceMappingURL=chunk-UW3XDKYU.mjs.map